import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import { useScriptMode } from "../../../contexts/ScriptModeContext";
import { isRangeType } from "../../../lib/hatimType";
import { SoftBar, SoftButton, SoftRow, SoftTag, cls, progressColor, useIsDark } from "../soft/SoftKit";

function statusKey(s) {
  if (s === "completed") return "hatim_card_completed_status";
  if (s === "pending") return "hatim_card_pending_status";
  return "hatim_card_in_progress_status";
}

/** Hatimlerim satırı: kitap simgesi, ad, pay, ince çubuk ve Güncelle. */
export default function HatimCard({ instance, onUpdate }) {
  const { t } = useScriptMode();
  const dark = useIsDark();
  const a = instance.myAssignment;
  const isRange = isRangeType(instance.type);
  const book = <MenuBookOutlinedIcon sx={{ fontSize: 18 }} aria-hidden />;

  if (!a) {
    return (
      <SoftRow avatar={book} title={instance.name} meta={t("hatim_card_no_assignment")} />
    );
  }

  const completed = a.completedAmount || 0;
  const assigned = a.assignedAmount || 0;
  const pct = assigned > 0 ? Math.min(100, Math.round((completed / assigned) * 100)) : 0;
  const ranges = Array.isArray(a.assignedPageRanges) ? a.assignedPageRanges : [];
  const assignedText = isRange
    ? ranges.map((r) => `${r.startPage}–${r.endPage}`).join(", ") || "-"
    : `${assigned} ${t("hatim_card_assigned_amount")}`;

  return (
    <SoftRow
      avatar={book}
      title={instance.name}
      titleAccessory={<SoftTag>{t(statusKey(a.status))}</SoftTag>}
      meta={
        <span>
          {t("hatim_card_assigned_label")}: {assignedText}
        </span>
      }
      right={
        <SoftButton tone="soft" size="small" onClick={() => onUpdate(instance)}>
          {t("hatim_card_update_cta")}
        </SoftButton>
      }
    >
      <div className="flex items-center gap-3 pl-12">
        <SoftBar pct={pct} color={progressColor(pct, dark)} />
        <span className={`text-xs shrink-0 ${cls.muted}`}>
          {t("hatim_card_progress_label")}: {completed} / {assigned}
        </span>
      </div>
    </SoftRow>
  );
}
